import {
  type DepositProduct,
  InterestRateType,
} from '@/types/consumer-deposit-application-service';

/**
 * A fixed product the backend sends with several configuration rules lets the
 * customer pick a term, so it gets the fixed term view and its progress step.
 */
export const hasFixedTermView = (
  product: DepositProduct | undefined,
): boolean =>
  product?.interestType === InterestRateType.FIXED &&
  (product.configurationRules?.length ?? 0) > 1;
